module.exports = __webpack_public_path__ + "17c29b3f8bbe8e0632d41788315da6da.svg";